import {
  GET_OTAP_AGENTS_API,
  SEARCH_OTAP_AGENT_QUEUES_API,
  CANCEL_MULTIPLE_OTAP_API
} from '~/constants/APIs'
import {
  IOtapAgentOption,
  IOtapAgentQueueRequest,
  IOtapAgentQueueResponse,
  ICancelMultipleOtapForm
} from '~/models'
import axiosClient from './axiosClient'

export const otapAgentQueueApis = {
  searchOtapAgentQueues: (params: IOtapAgentQueueRequest | null) =>
    axiosClient.get(SEARCH_OTAP_AGENT_QUEUES_API, {
      params
    }) as unknown as IOtapAgentQueueResponse,
  getOtapAgents: () =>
    axiosClient.get(GET_OTAP_AGENTS_API) as unknown as IOtapAgentOption[],
  cancelOtap: (data: ICancelMultipleOtapForm) =>
    axiosClient.post(CANCEL_MULTIPLE_OTAP_API, data)
}
